import { formatPayloadDate } from 'utils/helpers'
import { getCIF } from './helpers'

export const toLegalPersonPayload = values => ({
  ...values,
  cif: getCIF(values.cif),
  delegate: {
    ...values.delegate,
    identityCardIssuingDate: formatPayloadDate(values.delegate.identityCardIssuingDate)
  }
})
